// extracted by mini-css-extract-plugin
module.exports = {"bg":"_2FBKN","inlineContent":"_1VShg","pageWrapper":"rcpjB","root":"_2txMn"};